// src/firebase.js

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBVQuh_-oQF6kffC7I1hkyXYm06OmMEtTQ",
  authDomain: "wally-market.firebaseapp.com",
  projectId: "wally-market",
  storageBucket: "wally-market.firebasestorage.app",
  messagingSenderId: "1096817795812",
  appId: "1:1096817795812:web:e83b6983b1a81fcdd582f1",
  measurementId: "G-V905TSG4WZ",
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

export { getToken, onMessage };
